import { render, staticRenderFns } from "./LogoCabinet.vue?vue&type=template&id=2fa6cbd6&"
import script from "./LogoCabinet.vue?vue&type=script&lang=js&"
export * from "./LogoCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports